import Collapse from './src/Collapse';

export default Collapse;
export const Panel = Collapse.Panel;



// WEBPACK FOOTER //
// ./ext/collapse/index.js